import {HomeScreens, ShopperScreens} from '@buncha/home/navigation/types';
import React, {useCallback, useMemo} from 'react';
import {
  useBuyerManagement,
  useItemDetailsContext,
} from '../../../hooks/ItemDetails';

import {Box} from '../../../../components/core/view';
import BuyerInfo from '../BuyerInfo/BuyerInfo';
import {Buyers} from '../../../types/itemDetails';
import {Skeleton} from 'native-base';
import {navigation} from '@buncha/config/navigation';
import {styles} from './styles';
import {useRoute} from '@react-navigation/native';

interface BuyerDetailsProps {
  isMenu: boolean;
  isCustomItem: boolean;
  loadingBuyer?: boolean;
}

const BuyerDetails = (props: BuyerDetailsProps) => {
  const {isMenu, isCustomItem, loadingBuyer} = props;
  const {state, dispatch} = useItemDetailsContext();
  const {constants} = state;
  const isEnabled = constants?.CHAT_ENABLE === 'true';
  const {getBuyersForItem} = useBuyerManagement(dispatch);
  const routeParams: any = useRoute()?.params;
  const catalogItemId = Number(routeParams?.catalogItemId) || 0;

  const orderItemId = Number(routeParams?.orderItemId) || 0;
  const runId = Number(routeParams?.runId) || 0;

  const refreshBuyers = useCallback(async () => {
    if (runId && orderItemId) {
      const res = await getBuyersForItem(runId, orderItemId, catalogItemId);

      if (!res)
        navigation.navigate(HomeScreens.Shopper, {
          screen: ShopperScreens.BatchDetailsPage,
          params: {
            runId: runId,
          },
        });
    }
  }, [catalogItemId, getBuyersForItem, orderItemId, runId]);

  const renderBuyers = useMemo(() => {
    if (loadingBuyer)
      return (
        <Box style={styles.renderContainer}>
          <Skeleton.Text px="4" />
          <Skeleton px="4" my="4" rounded="md" startColor="primary.100" />
        </Box>
      );
    return state?.buyersForItem?.map((buyer: Buyers, index: number) => {
      return (
        <BuyerInfo
          key={buyer.id}
          buyers={buyer}
          isMenu={isMenu}
          isCustomItem={isCustomItem}
          chatEnable={isEnabled}
          dispatch={dispatch}
          item={state?.item}
          isOosSubstitute={false}
          refreshBuyers={refreshBuyers}
          showDivider={index !== state?.buyersForItem?.length - 1}
        />
      );
    });
  }, [
    loadingBuyer,
    state?.buyersForItem,
    state?.item,
    isMenu,
    isCustomItem,
    isEnabled,
    dispatch,
    refreshBuyers,
  ]);

  return (
    <Box style={[styles.container]}>
      {/* <ContactDisclaimer /> */}
      {renderBuyers}
    </Box>
  );
};

export default React.memo(BuyerDetails);
